import { type ValidateStatus } from "antd/es/form/FormItem";
// import yaml from "js-yaml";
import YAML from "yaml";
import jsYaml from "js-yaml";

const yamlModulesReplacer = (key: string, value: any): any | undefined => {
  if (value !== null) {
    return value;
  }
  return undefined;
};

export const objectToYaml = (
  value: any,
  excludeNull: boolean = false,
): string => {
  if (value == null) return "";
  return jsYaml.dump(value, {
    quotingType: '"',
    forceQuotes: true,
    replacer: excludeNull ? yamlModulesReplacer : undefined,
  });
};

export const yamlValidate = async (_: any, value: any): Promise<any> => {
  console.log("value", value);
  try {
    const yamlParsed = YAML.parse(value);
    console.log("yaml load  params", yamlParsed, typeof yamlParsed);
    if (typeof yamlParsed === "string")
      return await Promise.reject(new Error("Некорректный yaml"));
    await Promise.resolve();
  } catch (err) {
    return await Promise.reject(new Error("Некорректный yaml"));
  }
};

export const validateParams = (
  value: string,
): {
  validateStatus: ValidateStatus;
  errorMsg: string | null;
} => {
  try {
    const yamlParsed = YAML.parse(value);
    console.log("yaml load  params", yamlParsed);
    return {
      validateStatus: "success",
      errorMsg: null,
    };
  } catch (err) {
    return {
      validateStatus: "error",
      errorMsg: "Некорректный yaml",
    };
  }
};
